<template>
  <div class="container-fluid">
    <card-list></card-list>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
            <div class="card-header bg-transparent text-left">
              <strong> Contas a pagar</strong>
            </div>

            <div class="card-body">
              <bills-to-pay :height="300" >
              </bills-to-pay>
            </div>
        </div> 
      </div>
      <div class="col-md-6">
        <div class="card">
            <div class="card-header bg-transparent text-left">
              <strong>Contas a receber</strong>
            </div>

            <div class="card-body">
              <bills-to-receive :height="300" >
              </bills-to-receive>
            </div>
        </div>
      </div>
    </div>
    <div class="row">
        <grid-bills-to-pay></grid-bills-to-pay>
        <grid-bills-to-receive></grid-bills-to-receive>
    </div>
    <!-- <div class="row">
      <div class="col-md-6">
        <div class="card">
            <div class="card-header bg-transparent text-left">
              <strong>Contas a pagar</strong>
            </div>

            <div class="card-body">
              <bills-to-pay-by-month></bills-to-pay-by-month>
            </div>
        </div> 
      </div>
      <div class="col-md-6">
        <div class="card">
            <div class="card-header bg-transparent text-left">
              <strong>Contas a receber</strong>
            </div>

            <div class="card-body">
              <bills-to-receive-by-month></bills-to-receive-by-month>
            </div>
        </div> 
      </div>
    </div> -->
  </div>
</template>

<script>
// @ is an alias to /src
import cardList from '@/components/cardlists/dashFinanceiro.vue'
import billsToPay from '@/components/graphs/billsToPay.vue'
import billsToReceive from '@/components/graphs/billsToReceive.vue'
import billsToPayByMonth from '@/components/graphs/billsToPayByMonth.vue'
import billsToReceiveByMonth from '@/components/graphs/billsToReceiveByMonth.vue'
import gridBillsToPay from '@/components/grids/billstopay.vue'
import gridBillsToReceive from '@/components/grids/billstoreceive.vue'

export default {
  name: 'vwDashCaixa',
  components: {
    cardList,
    billsToPay,
    billsToReceive,
    billsToPayByMonth,
    billsToReceiveByMonth,
    gridBillsToPay,
    gridBillsToReceive
  }
}
</script>
<style scoped>
  .col-md-6,
  .col-md-4,
  .col-md-8{
    margin-bottom: 10px;
  }
</style>